/* global StarWebPrintBuilder, StarWebPrintPort */
import React, { useEffect, useState, useCallback, useRef } from "react";
import { useLocation } from "react-router-dom";
import { formatJournalForPrint } from "../utils/formatJournalForPrint";
import { apiRequest } from "../utils/api";
import { useAlert } from "../components/AlertModal";
import "../styles/JournalPrintView.css";
import "../styles/Print.css";

function getQueryParam(search, key) {
  return new URLSearchParams(search).get(key);
}

export default function JournalPrintView() {
  const location = useLocation();
  const date = getQueryParam(location.search, "date");
  const [printText, setPrintText] = useState("");
  const { showAlert } = useAlert();
  const printedRef = useRef(false);

  const printWithStarPrinter = useCallback((text) => {
    if (!text) return;

    if (
      typeof StarWebPrintBuilder === "undefined" ||
      typeof StarWebPrintPort === "undefined"
    ) {
      showAlert("StarWebPrint SDK が読み込まれていません。");
      return;
    }

    try {
      const builder = new StarWebPrintBuilder();

      let request = "";
      request += builder.createInitializationElement();
      request += builder.createTextElement({ data: text + "\n\n\n" });
      request += builder.createCutPaperElement({ feed: true });
      request += builder.createPeripheralElement({ channel: 1 });

      const port = new StarWebPrintPort();

      port.onReceive = function (res) {
        if (res.success) {
          console.log("ジャーナル印刷成功");
          window.close();
        } else {
          console.error("ジャーナル印刷失敗:", res.code);
          showAlert(`ジャーナル印刷に失敗しました（コード: ${res.code}）`);
        }
      };

      port.onError = function (err) {
        console.error("プリンタ接続エラー:", err);
        showAlert("プリンタに接続できませんでした。StarWebPRNTが起動しているか確認してください。");
      };

      port.open("localhost", "StarWebPRNT", 8001);
      port.send(request);
    } catch (err) {
      console.error("ジャーナル印刷エラー:", err);
      showAlert("ジャーナル印刷中にエラーが発生しました。");
    }
  }, [showAlert]);

  useEffect(() => {
    if (!date) {
      showAlert("印刷日付が指定されていません。");
      return;
    }

    if (printedRef.current) return;
    printedRef.current = true;

    const fetchData = async () => {
      try {
        const data = await apiRequest(`inventory/journal/print/?date=${date}`, "GET");
        const formatted = formatJournalForPrint(data, date);

        setPrintText(formatted);

        if (!formatted.trim()) {
          showAlert("印刷するジャーナルデータがありません。");
          return;
        }

        printWithStarPrinter(formatted);
      } catch (error) {
        console.error("印刷データ取得エラー:", error);
        showAlert("印刷データ取得に失敗しました。");
      }
    };

    fetchData();
  }, [date, printWithStarPrinter, showAlert]);

  return (
    <pre className="journal-print-container">
      {printText || "ジャーナル印刷データを取得中..."}
    </pre>
  );
}